export var isDOMElement = function isDOMElement(maybeNode) {
  return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};